// extracted by mini-css-extract-plugin
export default {"container":"ExerciseControlPanelContainer_container__FKy84","leftText":"ExerciseControlPanelContainer_leftText__i1lo9","buttons":"ExerciseControlPanelContainer_buttons__LWdtm"};